import React from 'react';
import { FasTimes, FasPencilAlt } from 'assets/icons';

const Edit = props => {
    const { mode, setMode, resetForm, formProps } = props;
    const getTitle = () => {
        let title = '';
        if (mode) {
            title = 'Close';
          } else {
            title = 'Edit';
          }
          return title;
        };
        return (
          <>
            <button
              type="button"
              onClick={() => {
                if (mode) {
                  resetForm(formProps);
                }
                setMode(!mode);
              }}
              className="fn-btn edit"
              title={getTitle()}
            >
              {mode ? <FasTimes /> : <FasPencilAlt />}
            </button>
          </>
        );
};

export default Edit;